import { makeAutoObservable } from 'mobx'

import { UserApi } from '../api'
import type { User, UserFeature, UserProfile } from '../types'

import { GlobalStore } from './GlobalStore'

export class UserStore {
  globalStore: GlobalStore
  api: UserApi = new UserApi('/', '')

  userFeatures: UserFeature[] = []
  userFeaturesLoaded: boolean = false

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore
    this.api = new UserApi(globalStore.endpoint, globalStore.sessionToken, globalStore.onError)

    makeAutoObservable(this)
  }

  get userProfile() {
    return this.globalStore.appDataStore.userProfile
  }

  get user() {
    return this.globalStore.appDataStore.user
  }

  setUserFeatures = (features: UserFeature[]) => {
    this.userFeatures = features
    this.userFeaturesLoaded = true
  }

  loadUserFeatures = async () => {
    try {
      const features = await this.api.getUserFeatures()
      this.setUserFeatures(features)
    } catch (e) {
      console.error('Error occurred while loading user features:', e)
      this.globalStore.captureException(e, { store: 'UserStore' })
      this.setUserFeatures([])
    }
  }

  updateUser = async (user: User) => {
    try {
      const updatedUser = await this.api.updateUser(user)

      this.globalStore.appDataStore.setUser(updatedUser)
    } catch (error) {
      console.error('Error updating User:', error)
      this.globalStore.captureException(error, { store: 'UserStore' })
      throw error
    }
  }

  updateUserProfile = async (userProfile: UserProfile) => {
    try {
      const updatedProfile = await this.api.updateUserProfile(userProfile)

      this.globalStore.appDataStore.setUserProfile(updatedProfile)
    } catch (error) {
      console.error('Error occurred while updating user profile:', error)
      this.globalStore.captureException(error, { store: 'UserStore' })
    }
  }
}
